

<div class="sub-container parent row">
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-centered">
        <div class="form-group">
            <p class="parent-heading">Earn Rewards and Save Favorites When You Join MyWhataburger</p>
          </div>
          <div class="row mg-top-18">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <app-alert *ngIf="showErrorMessage" [alertService]="alertService"></app-alert>
            </div>

          <form (ngSubmit)="onSubmit()" [formGroup]="signupForm" novalidate>
            <div class="form-group">
              <label>Email</label>
              <input type="email" class="form-control" formControlName="email" />
              <app-validation-message [control]="signupForm.controls.email" class="form-error"></app-validation-message>
            </div>

              <div class="form-group">
                <label>First Name</label>
                <input type="text" class="form-control" formControlName="firstname" maxlength="20" />
                <app-validation-message [control]="signupForm.controls?.firstname" class="form-error">
                </app-validation-message>
              </div>
              <div class="form-group">
                <label>Last Name</label>
                <input type="text" class="form-control" formControlName="lastname" maxlength="20" />
                <app-validation-message [control]="signupForm.controls.lastname" class="form-error">
                </app-validation-message>
              </div>
            
              <div class="form-group">
                <label>Zip code</label>
                <input type="text" class="form-control" formControlName="zipcode" maxlength="5" />
                <app-validation-message [control]="signupForm.controls.zipcode" class="form-error"></app-validation-message>
              </div>

             
              <div formGroupName="passwords">
                <div class="form-group">
                  <label>Create Password</label>
                  <input type="password" class="form-control" formControlName="password" />
                  <app-validation-message [control]="signupForm['controls'].passwords['controls'].password" class="form-error"></app-validation-message>
                  <div class="password-reqs text-left">
                    <span class="hint-text">Your password must be at least 8 characters (20 max) with no spaces. It must meet 2 of these requirements: 1 special character; 1 uppercase; 1 lowercase; 1 number.
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label>Confirm Password</label>
                  <input type="password" class="form-control" formControlName="confPw" />
                  <app-validation-message [control]="signupForm['controls'].passwords['controls'].confPw" class="form-error"></app-validation-message>
                </div>
              </div>

              <div class="form-group">
                <div class="custom-sm-checkbox mg-top-7">
                  <input type="checkbox" id="addToEmail" formControlName="addToEmail" />
                  <label class="mg-btm-0" for="addToEmail"> Email Me Offers and News</label>
                </div>
              </div>

              <div class="form-group">
                <div class="custom-sm-checkbox">
                  <input type="checkbox" id="termncondn"  formControlName="termncondn" />
                  <label class="mg-btm-0" for="termncondn">I agree to the &nbsp;
                  </label>
                  <a (click)="showTerms()" class="termncondns"> Terms & Conditions</a>
                </div>
              </div>

              <div class="form-group">
                <button type="submit" class="btn wb-btn-default center-block" [disabled]="!signupForm.valid || loading ">
                  Create Account
                </button>
              </div>
  
          </form>
    </div>

</div>
